/*
 * Created on Thu Oct 12 2023 10:26:22 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import EditForm from "./EditForm";

export const EditProfile = () => {
  const location = useLocation();
  const nav = useNavigate();

  // Function to update localStorage every second
  const updateLocalStorage = () => {
    // Update your localStorage value here
    // For example, update a timestamp or any other data
    localStorage.setItem("lastUpdated", new Date().toLocaleString());
  };

  useEffect(() => {
    // Update localStorage every second
    const localStorageUpdater = setInterval(updateLocalStorage, 1000);

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(localStorageUpdater);
    };
  }, []);

  useEffect(() => {
    const cond = localStorage.getItem("isLoggedIn");
    if (!cond) {
      nav("/sign-in");
    } else if (!location.state?.userInfo) {
      nav("/Profile");
    }
  }, [location, nav]);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div
        className="overflow-hidden bg-white shadow-2xl"
        style={{
          marginTop: "50px",
          boxSizing: "border-box",
          color: "#111",
          borderRadius: "2%",
        }}
      >
        <div className="flex flex-col items-center justify-center bg-[#003366] p-4 text-white">
          <h1 className="font-sans text-lg font-bold">Please complete your profile</h1>
        </div>
        {/* {userInfo && <EditForm id="edit-profile-details" data={userInfo} />} */}
      </div>
    </div>
  );
};
